import { IconWrapper } from '../runtime';
export default IconWrapper('success-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + '25ff66d1' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      "fill": "#009D44"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.6011 5.19891C12.933 5.53086 12.933 6.06905 12.6011 6.40099L7.78121 11.2208C7.44926 11.5528 6.91107 11.5528 6.57913 11.2208L3.89898 8.5407C3.56704 8.20876 3.56704 7.67057 3.89898 7.33862C4.23093 7.00668 4.76912 7.00668 5.10107 7.33862L7.18017 9.41772L11.399 5.19891C11.7309 4.86696 12.2691 4.86696 12.6011 5.19891Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + '25ff66d1'
    }
  }, [h("rect", {
    "attrs": {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
});